import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentActionsListComponent } from './payment-actions-list/payment-actions-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: PaymentActionsListComponent,
        data: {
          title: 'Payment Actions'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentActionsRoutingModule {
}
